import { render, staticRenderFns } from "./purchase_order_detail.vue?vue&type=template&id=0a5fcd96&scoped=true"
import script from "./purchase_order_detail.vue?vue&type=script&lang=js"
export * from "./purchase_order_detail.vue?vue&type=script&lang=js"
import style0 from "./purchase_order_detail.vue?vue&type=style&index=0&id=0a5fcd96&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5fcd96",
  null
  
)

export default component.exports